export { default } from './InlinePageHeading';
export * from './InlinePageHeading';
